<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card v-if="activity">
      <v-card-title>
        <span class="headline">{{ $t("itinerary.ActivityCloner.currentActivity") }}</span>
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col v-show="forExport" cols="6">
            <v-text-field
              label="Trip Name"
              disabled
              :value="tripName(currentTripId)"
            ></v-text-field>
          </v-col>
          <v-col :cols="forExport ? 6 : 12">
            <v-text-field label="Event Name" disabled :value="activity.name"></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              class="my-0"
              :label="$t('common.date')"
              disabled
              :value="originalDate | zonedDate('P', activity.display_timezone)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" v-if="!activity.all_day">
            <v-text-field
              class="my-0"
              :label="$t('common.time.time')"
              disabled
              :value="originalDate | zonedDate('p', activity.display_timezone)"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-title class="mt-n4">
        <span class="headline">{{ $t("common.newActivity") }}</span>
      </v-card-title>
      <v-card-text>
        <v-select
          v-show="forExport"
          :items="trips"
          v-model="cloneTripIds"
          item-text="name"
          multiple
          item-value="id"
          :label="$t('itinerary.exporter.selectLabel')"
        ></v-select>
        <v-row dense v-for="(value, i) in newDates" :key="i">
          <v-col cols="12" md="5">
            <DatePickerField v-model="newDates[i].date" />
          </v-col>
          <v-col cols="12" md="5" class="d-flex flex-row align-center">
            <v-icon class="ml-4">mdi-clock-outline</v-icon>
            <vue-timepicker
              class="ml-2"
              fixed-dropdown-button
              format="h:mm a"
              :placeholder="$t('common.time.time')"
              v-model="newDates[i].time"
              manual-input
              v-if="!activity.all_day"
            ></vue-timepicker>
          </v-col>
          <v-col cols="2">
            <v-btn
              v-if="i == newDates.length - 1"
              icon
              color="primary"
              @click="addDate()"
              class="ml-3 mt-3"
            >
              <v-icon>mdi-plus-circle-outline</v-icon>
            </v-btn>
            <v-btn v-else icon color="primary" class="ml-3 mt-3" @click="newDates.splice(i, 1)">
              <v-icon>mdi-minus-circle-outline</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <p class="red--text text-right" v-show="feedback">{{ feedback }}</p>
      </v-card-text>
      <v-card-actions style="margin-top: 80px">
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close">{{ $t("common.close") }}</v-btn>
        <v-btn color="primary" @click="save">{{ $t("common.save") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import { parseISO } from "date-fns";
// import { format, utcToZonedTime } from "date-fns-tz";
import moment from "moment-timezone";
import DatePickerField from "@/components/Base/DatePickerField";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";

export default {
  name: "ActivitySettings",
  props: ["activity", "forExport"],
  components: { DatePickerField, VueTimepicker },
  data() {
    return {
      newDates: [],
      cloneTripIds: [],
      feedback: null,
    };
  },
  methods: {
    addDate() {
      const { activity } = this.$props;
      const date = this.originalDate;
      const momentDate = moment(date).tz(activity.display_timezone || "UTC");
      this.newDates.push({
        date: momentDate.format("YYYY-MM-DD"),
        time: {
          h: momentDate.format("h"),
          mm: momentDate.format("mm"),
          a: momentDate.format("a"),
        },
      });
    },
    save() {
      const dates = this.newDates.map(({ time: eventTime, date: eventDate }) => {
        const isoTime = `${eventTime.h}:${eventTime.mm} ${eventTime.a.toLowerCase()}`;
        const isoDate = `${eventDate} ${isoTime}`;
        const utc = moment(isoDate, "YYYY-MM-D h:mm a");
        const localDate = utc.toDate();
        const { activity } = this.$props;
        if (activity.remote_tz) {
          const tzDifference =
            moment.tz.zone(activity.display_timezone).utcOffset(localDate.getTime()) -
            localDate.getTimezoneOffset();

          return new Date(localDate.getTime() + tzDifference * 60 * 1000);
        }
        const offset = moment.tz.zone(activity.display_timezone).utcOffset(localDate.getTime());
        const tzDifference = offset - localDate.getTimezoneOffset();
        return new Date(localDate.getTime() + tzDifference * 60 * 1000);
      });
      let tripIds;

      if (this.$props.forExport) {
        if (this.cloneTripIds.length > 0) {
          tripIds = this.cloneTripIds;
        } else {
          this.feedback = this.$t("itinerary.ActivityCloner.exportFeedback");
          return;
        }
      } else {
        tripIds = [this.currentTripId];
      }

      this.$emit("saved", { tripIds, dates });
    },
    close() {
      this.$emit("saved");
    },
    tripName(tripId) {
      return this.$store.state.userTrips.find((trip) => trip.id === tripId).name;
    },
  },
  computed: {
    originalDate() {
      if (this.activity.location) {
        return this.activity.location.date.toDate();
      }
      return this.activity.origin.date.toDate();
    },
    dialog() {
      return this.$props.activity != null;
    },
    currentTripId() {
      return this.$store.getters.currentTripId;
    },
    trips() {
      return this.$store.getters.activeTrips;
    },
  },
  created() {
    this.addDate();
  },
};
</script>
